import client from './client';

/**
 * Menu categories sourced from orders.co-mms (via api01), used to tag an
 * inventory item with the menu category it maps to.
 */
export const getCategories = (businessUuid) =>
  client
    .get('/categories', { params: businessUuid ? { businessUuid } : undefined })
    .then((r) => r.data);
